import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, from, map, of, switchMap } from 'rxjs';
import { VehicleApiService } from '../../api/vehicle-api.service';
import { actions } from './models-vm.actions';

@Injectable()
export class ModelsVMEffects {
    actions$ = inject(Actions);
    vehicleApi = inject(VehicleApiService);
    store = inject(Store);

    loadModelList$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.loadModelVMList),
            switchMap(() =>
                from(this.vehicleApi.getModelList()).pipe(
                    map((modelList) => actions.loadModelVMListSuccess({ modelList })),
                    catchError((error) => of(actions.loadModelVMListFailure({ error }))),
                ),
            ),
        );
    });
}
